/*
 * argile-recently-viewed.js — « Consultés récemment ».
 * Lit les fiches produit stockées dans localStorage (clé `argile-recently-viewed`,
 * alimentée par le tracking de argile-head sur les pages produit), reconstruit
 * les cartes et câble le slider (argile-slider.js). Aucun fetch.
 * Si rien à afficher → la section se retire.
 */
(() => {
  /* v2 : bump après le fix « pas de poster vidéo en thumbnail » — invalide les
     anciennes entrées (qui pouvaient stocker le poster d'une vidéo en 1er média). */
  const KEY = 'argile-recently-viewed-v2';

  const escapeHtml = (str) =>
    String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  let ctaLabel = 'Acheter un échantillon';

  const buildCard = (item) => {
    const el = document.createElement('article');
    el.className = 'argile-rv-card';
    el.setAttribute('data-slider-slide', '');

    el.innerHTML =
      // Lien overlay : toute la carte mène au produit (le « + » passe au-dessus).
      '<a class="argile-rv-card__link" href="' +
      escapeHtml(item.url || '#') +
      '"><span class="visually-hidden">' +
      escapeHtml(item.title) +
      '</span></a>' +
      '<span class="argile-rv-card__media">' +
      (item.image
        ? '<img class="argile-rv-card__img" src="' +
          escapeHtml(item.image) +
          '" alt="' +
          escapeHtml(item.title) +
          '" loading="lazy">'
        : '') +
      '</span>' +
      '<span class="argile-rv-card__titlerow">' +
      '<span class="argile-card-title">' +
      escapeHtml(item.title) +
      '</span>' +
      (item.family
        ? '<span class="argile-card-family">' + escapeHtml(item.family) + '</span>'
        : '') +
      '</span>' +
      '<span class="argile-card-cta">' +
      '<span class="argile-card-cta__label">' + escapeHtml(ctaLabel) + '</span>' +
      '<span class="argile-card-cta__arrow" aria-hidden="true">→</span>' +
      '</span>';
    return el;
  };

  const init = (root) => {
    if (root.dataset.argileRvDone) return;
    root.dataset.argileRvDone = '1';
    ctaLabel = root.dataset.ctaLabel || ctaLabel;

    const track = root.querySelector('[data-slider-track]');
    const slider = root.querySelector('[data-argile-slider]');
    if (!track || !slider) return;

    let items = [];
    try {
      items = JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch (e) {
      items = [];
    }

    const limit = parseInt(root.getAttribute('data-limit') || '12', 10);
    // Exclure le produit courant si on est sur sa page.
    const current =
      document.querySelector('[data-argile-current-product]')?.getAttribute(
        'data-argile-current-product'
      ) || null;

    items = items
      .filter((it) => it && it.handle && it.handle !== current)
      .slice(0, limit);

    if (!items.length) {
      root.remove();
      return;
    }

    const frag = document.createDocumentFragment();
    items.forEach((it) => frag.appendChild(buildCard(it)));
    track.appendChild(frag);

    root.classList.add('is-ready');

    // (Re)câble le slider : on lève le garde-fou puis on déclenche l'init.
    slider.removeAttribute('data-argile-wired');
    root.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
  };

  const boot = () => {
    document
      .querySelectorAll('[data-argile-recently-viewed]')
      .forEach((root) => init(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Éditeur : ré-ajout de la section.
  document.addEventListener('shopify:section:load', (event) => {
    const root =
      event.target.matches && event.target.matches('[data-argile-recently-viewed]')
        ? event.target
        : event.target.querySelector?.('[data-argile-recently-viewed]');
    if (root) init(root);
  });
})();
